"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ApiError extends Error {
    constructor(error) {
        super(error.message);
        this.name = 'ApiError';
        // Find error message
        if (error.response && error.response.data) {
            if (error.response.data.error_description.message) {
                this.message = error.response.data.error_description.message;
            }
            else {
                this.message = error.response.data.error_description;
            }
        }
        else {
            this.message = error.message;
        }
        if (error.response) {
            this.response = error.response;
            this.statusCode = this.response.status;
        }
    }
}
exports.default = ApiError;
//# sourceMappingURL=api_error.js.map